import { reviewsFormat } from '@/pages/opinion/utils/value';
import React from 'react';
import { useIntl } from 'react-intl';
import { StatusTip, Table } from 'tea-component';

const { scrollable } = Table.addons;
export default function DauTable({
  originalData,
}: {
  originalData: Array<any>;
}) {
  const { formatMessage } = useIntl();

  return (
    <div>
      <Table
        verticalTop
        records={originalData}
        recordKey="id"
        columns={[
          {
            key: 'date',
            header: formatMessage({ id: 'Date' }),
            fixed: 'left',
            width: 120,
          },
          {
            key: 'rank',
            header: formatMessage({ id: 'Rank' }),
            width: 80,
            align: 'right',
            render: ({ rank }) => reviewsFormat(rank),
          },
          {
            key: 'today',
            header: formatMessage({ id: 'Search index(Today)' }),
            align: 'right',
            render: ({ today }) => reviewsFormat(today),
          },
          {
            key: 'yesterday',
            header: formatMessage({ id: 'Search index(Last Day)' }),
            align: 'right',
            render: ({ yesterday }) => reviewsFormat(yesterday),
          },
        ]}
        topTip={
          originalData.length === 0 && (
            <StatusTip
              style={{ height: 230, lineHeight: '230px' }}
              status="empty"
            />
          )
        }
        addons={[
          scrollable({
            maxHeight: 262,
          }),
        ]}
      />
    </div>
  );
}
